import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const pomkitchenApi = api
  .enhanceEndpoints({ addTagTypes: ['POMKitchen'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOMKitchens: builder.query<po_mkitchen[], string>({
        query: cid => `pomkitchen/${cid}`,
        providesTags: ['POMKitchen']
      }),
      getPOMKitchenById: builder.query<po_mkitchen, string>({
        query: id => `pomkitchen/byid/${id}`,
        providesTags: ['POMKitchen']
      }),
      insertPOMKitchen: builder.mutation({
        query: pomkitchen => ({
          url: `pomkitchen/`,
          method: 'POST',
          body: pomkitchen
        }),
        invalidatesTags: ['POMKitchen']
      }),
      updatePOMKitchen: builder.mutation({
        query: pomkitchen => ({
          url: `pomkitchen/`,
          method: 'PUT',
          body: pomkitchen
        }),
        invalidatesTags: ['POMKitchen']
      }),
      deletePOMKitchen: builder.mutation({
        query: pomkitchen => ({
          url: `pomkitchen/${pomkitchen.kt_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POMKitchen']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOMKitchensQuery,
  useGetPOMKitchenByIdQuery,
  useInsertPOMKitchenMutation,
  useUpdatePOMKitchenMutation,
  useDeletePOMKitchenMutation
} = pomkitchenApi;

